import { tooltipClasses } from "@mui/material";
import { styled } from "@mui/system";
import CircleIcon from "@mui/icons-material/Circle";

import { colors } from "../../../../../styles/colors";

export const NotesTooltip = () => ({
  textOverflow: "ellipsis",
  overflow: "hidden",
  maxWidth: "18rem",
  display: "-webkit-box",
  WebkitLineClamp: "2",
  WebkitBoxOrient: "vertical",
});

export const CheckEligibilityTooltip = () => ({
  textOverflow: "ellipsis",
  overflow: "hidden",
  maxWidth: "43rem",
  display: "-webkit-box",
  WebkitLineClamp: "2",
  WebkitBoxOrient: "vertical",
});

export const NotesCommentTooltip = () => ({
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  maxWidth: "18rem",
  display: "-webkit-inline-box",
  WebkitLineClamp: "2",
  WebkitBoxOrient: "vertical",
});

export const NotesTooltipStyle = {
  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
    {
      marginTop: "0.4rem",
      marginLeft: "-5rem",
      maxWidth: "50rem",
    },
};

export const FilterAltIconStyle: any = (disabled: boolean) => ({
  height: "1.25rem",
  width: "1.25rem",
  display: "flex",
  color: disabled ? colors.disabled : colors.fonts[26],
  cursor: disabled ? "not-allowed" : "pointer",
  pointerEvents: disabled ? "none" : "auto",
});

export const FilterCircleIconStyle: any = styled(CircleIcon)(() => ({
  height: "0.50rem",
  width: "0.50rem",
  display: "flex",
  color: colors.fonts[26],
}));

export const FilterCircleIconStyleForNotes: any = styled(CircleIcon)(() => ({
  height: "1rem",
  width: "1rem",
  display: "flex",
  color: colors.fonts[26],
}));

export const FilterBoxStyle = {
  position: "relative",
  display: "inline-block",
};

export const RefFilterIconBoxStyle = {
  position: "absolute",
  top: 0,
  right: 0,
  zIndex: 2,
};

export const ButtonGrid = () => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "flex-end",
  paddingRight: "0.5rem",
});

export const NotesDownLoadIcon = {
  position: "absolute",
  top: "-1.0625rem",
  right: "-0.5rem",
  backgroundColor: colors.fonts[26],
  color: colors.white[1],
  borderRadius: "50%",
  width: "1.2rem",
  height: "1.2rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "0.75rem",
};
